module.exports = __webpack_public_path__ + "img/poster-2.2cd21ce1.jpg";